import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function NameField(props) {
    return (
        <FormikInput
            name={'name'}
            label={'shippingMethods.form.field.name.label'}
            placeholder={'shippingMethods.form.field.name.placeholder'}
            required={true}
        />
    );
}

export default NameField;
